import { Component, OnInit } from '@angular/core';
import { CommonService } from './../common.service';
import { Subject } from 'rxjs';
import { DatePipe } from '@angular/common';
import { CommonVariablesService } from './../common-variables.service';
@Component({
  selector: 'app-audit-trail',
  templateUrl: './audit-trail.component.html',
  styleUrls: ['./audit-trail.component.css']
})
export class AuditTrailComponent implements OnInit {

  constructor(private datePipe: DatePipe, private commonService: CommonService, private commonVariablesService: CommonVariablesService) { }
  dtTrigger: Subject<any> = new Subject();
  dtOptions: any = {};
  dataToTable = {}
  auditTrailData = [];
  changes = [];
  ngOnInit(): void {
	 window.localStorage.setItem('pageName','');
    this.dtOptions = {
      dom: "ftipr",
      destroy: true,
      bSort: false,
      autoWidth: false,
      "pageLength": 50,
    }
    this.onLoadingDataTable()
  }
	/*
	* Created By : Manasa R
	* Description : To order the data.
	*********************************************/
  GetSortOrder(prop) {
    return function (a, b) {
      if (a[prop] > b[prop]) {
        return 1;
      }
      else if (a[prop] < b[prop]) {
        return -1;
      }
      return 0;
    }
  }
	/*
	* Created By : Manasa R
	* Description : To load audit trail table data.
	*********************************************/
  async onLoadingDataTable() {
    /* let id = this.cookie.get('policyId').split(',');
    let status = this.cookie.get('policyStatus')
    let policyNumber = this.cookie.get('policyNumberForAuditTrail');
    let policyRef = this.cookie.get('referenceNumber'); */
	let idValue = window.localStorage.getItem('policyId')+'';
	let id = idValue.split(',');
    let status = window.localStorage.getItem('policyStatus')
    let policyNumber = window.localStorage.getItem('policyNumberForAuditTrail');
    let policyRef = window.localStorage.getItem('referenceNumber');
    let filterData = []
    if (status == '0') {
      for (let i = 0; i < id.length; i++) {
        // let parameter = {
        //   policy_id: id[i],
        // }
        let url = this.commonVariablesService.baseURL + 'api/v1/stats/history/' + id[i];
        let response = await this.commonService.httpGetMethod(url, '', true, '', 'audit Trail')
        if (response.status == 0) {
          for (let idx = response.data.length - 1; idx >= 1; idx--) {
            let j = idx - 1
            this.changes = [];
            let x = JSON.parse(response.data[idx].data) || {}
            let y = JSON.parse(response.data[j].data) || {}

            if (x.hasOwnProperty('sub_voyage')) {
              x.sub_voyage = x.sub_voyage.sort(this.GetSortOrder("id"));
              if (x.sub_voyage.length > 0)
                for (let inner_idx = 0; inner_idx < x.sub_voyage.length; inner_idx++) {
                  delete x.sub_voyage[inner_idx].id
                  delete x.sub_voyage[inner_idx].gc_running_id
                }
            }

            if (y.hasOwnProperty('sub_voyage')) {
              y.sub_voyage = y.sub_voyage.sort(this.GetSortOrder("id"));
              if (y.sub_voyage.length > 0)
                for (let inner_idx = 0; inner_idx < y.sub_voyage.length; inner_idx++) {
                  delete y.sub_voyage[inner_idx].id
                  delete y.sub_voyage[inner_idx].gc_running_id
                }
            }

            // delete response.data[i].data.sub_voyage.id
            await this.equalingJSON(x, y);
            // for (var key in data) {
            //   if(data[key]!="")
            //   this.changes.push(key + " : " + data[key])
            // }
            let data = this.changes.join("^")
            if (this.changes.length > 0) {
              let dataToTable = {};
              dataToTable['policyNumber'] = policyNumber;
                dataToTable['userId'] = response.data[idx - 1].author;
				dataToTable['server_time'] = (response.data[idx - 1]['u_ts']);
                dataToTable['dateTime'] = this.datePipe.transform(response.data[idx - 1]['u_ts'], "dd-MM-yyyy hh:mm:ss");
              dataToTable['description'] = data;
              filterData.push(dataToTable);
            }
          }
        }
        else if (response.status != -114) {
          this.commonService.errorsmsg(response.txt, 'Error');
        }
      }
    }
    else {
      let param = {
        policy_ref_num: policyRef
      }
      let url = this.commonVariablesService.baseURL + 'api/v1/marine_mp_gc_data/auditlog';
      let response = await this.commonService.httpGetMethod(url, '', true, param, 'audit Trail')
      if (response.status == 0) {
        for (let i = response.data.length - 1; i >= 1; i--) {
          let j = i - 1
          this.changes = [];
          delete response.data[i].data.proxy;
          delete response.data[j].data.proxy;
          delete response.data[i].data.author;
          delete response.data[j].data.author;
          delete response.data[i].data.ip;
          delete response.data[j].data.ip;
          delete response.data[i].data['c_ts'];
          delete response.data[j].data['c_ts'];
          delete response.data[i].data['u_ts'];
          delete response.data[j].data['u_ts'];
          delete response.data[i].data.gc_policy_status
          delete response.data[j].data.gc_policy_status
          delete response.data[j].data.policy_ref_num
          delete response.data[i].data.policy_number
          delete response.data[i].data.policy_ref_num
          delete response.data[j].data.policy_number
          delete response.data[j].data.policy_code
          delete response.data[i].data.policy_code
          delete response.data[i].data.policy_status
          delete response.data[j].data.policy_status
          let x = response.data[i].data
          let y = response.data[j].data
          if (x.hasOwnProperty('uploaded_data'))
            delete x['uploaded_data']
          if (y.hasOwnProperty('uploaded_data'))
            delete y['uploaded_data']
          if (x.hasOwnProperty('voyage')) {
            for (let count = 0; count < x['voyage'].length; count++) {
              delete x['voyage'][count].annual_estimate_turnover
              delete x['voyage'][count].voyage_description
              delete x['voyage'][count].bov_percentage
              delete x['voyage'][count].gc_running_id
              delete x['voyage'][count].policy_number
              delete x['voyage'][count].risk_detail_serial
              delete x['voyage'][count].mode_of_conveyance
              delete x['voyage'][count].per_seeding_limit
              delete x['voyage'][count].policy_ref_num
              delete x['voyage'][count].policy_number
              delete x['voyage'][count].rate_applicable
              if (x['voyage'][count].hasOwnProperty('sub_voyage'))
                x['voyage'][count].sub_voyage = x['voyage'][count].sub_voyage.sort(this.GetSortOrder("id"));
              if (x['voyage'][count].sub_voyage.length > 0)
                for (let idx = 0; idx < x['voyage'][count].sub_voyage.length; idx++) {
                  // delete x.sub_voyage[i].id
                  delete x['voyage'][count].sub_voyage[idx].gc_running_id
                  delete x['voyage'][count].sub_voyage[idx].id
                  delete x['voyage'][count].sub_voyage[idx].sub_voyage_gc_running_id
                  delete x['voyage'][count].sub_voyage[idx].policy_ref_num
                  delete x['voyage'][count].sub_voyage[idx].policy_number
                }
            }

          }
          if (y.hasOwnProperty('voyage')) {
            for (let count = 0; count < y['voyage'].length; count++) {
              delete y['voyage'][count].annual_estimate_turnover
              delete y['voyage'][count].voyage_description
              delete y['voyage'][count].bov_percentage
              delete y['voyage'][count].gc_running_id
              delete y['voyage'][count].policy_number
              delete y['voyage'][count].risk_detail_serial
              delete y['voyage'][count].mode_of_conveyance
              delete y['voyage'][count].per_seeding_limit
              delete y['voyage'][count].policy_ref_num
              delete y['voyage'][count].policy_number
              delete y['voyage'][count].rate_applicable
              if (y['voyage'][count].hasOwnProperty('sub_voyage'))
                y['voyage'][count].sub_voyage = y['voyage'][count].sub_voyage.sort(this.GetSortOrder("id"));
              if (y['voyage'][count].sub_voyage.length > 0)
                for (let idx = 0; idx < y['voyage'][count].sub_voyage.length; idx++) {
                  // delete x.sub_voyage[i].id
                  delete y['voyage'][count].sub_voyage[idx].gc_running_id
                  delete y['voyage'][count].sub_voyage[idx].id
                  delete y['voyage'][count].sub_voyage[idx].sub_voyage_gc_running_id
                  delete y['voyage'][count].sub_voyage[idx].policy_ref_num
                  delete y['voyage'][count].sub_voyage[idx].policy_number
                }
            }

          }
          await this.equalingJSON((response.data[i].data), (response.data[j].data));
          // let data = await this.equalingJSON((response.data[i].data), (response.data[j].data));
          // for (var key in data) {
          //   if(data[key]!="")
          //   this.changes.push(key + " : " + data[key])
          // }

          if (this.changes.length > 0) {
            let dataToTable = {};
            dataToTable['policyNumber'] = policyNumber;
              dataToTable['userId'] = (response.data[i - 1].author);
			  dataToTable['server_time'] = (response.data[i - 1]['c_ts']);
              dataToTable['dateTime'] = this.datePipe.transform(response.data[i - 1]['c_ts'], "dd-MM-yyyy hh:mm:ss");
            dataToTable['description'] = (this.changes).join("^");
            filterData.push(dataToTable);
          }
        }
      } else if (response.status != -114) {
        this.commonService.errorsmsg(response.txt, 'Error');
      }
    }
    let reducedArray = [];
    //unique records
    // reducedArray = await filterData.reduce((unique, o) => {
    //   if (!unique.some(obj => obj.dateTime === o.dateTime)) {
    //     unique.push(o);
    //   }
    //   return unique;
    // }, []);
    reducedArray = filterData;
    // for (let i = 0; i < filterData.length; i++) {
    //   for (let count= 0; count < reducedArray.length; count++) {
    //     if (filterData[i].dateTime.localeCompare(reducedArray[count].dateTime) == 0) {
    //       let userData = (reducedArray[count].userId).split(",")
    //       let index = userData.indexOf(filterData[i].userId)
    //       if (index == -1) {
    //         userData.push(filterData[i].userId)
    //         reducedArray[count].userId = userData.join(",");
    //       }

    //       let userDescription;
    //       if (status == "0")
    //         userDescription = reducedArray[count].description.split(",")
    //       else
    //         userDescription = reducedArray[count].description
    //       for (let count2 = 0; count2 < filterData[i].description; count2++) {
    //         let index1 = userDescription.indexOf(filterData[i].description[count2])
    //         if (index1 == -1)
    //           (userDescription).push(filterData[i].description[count2]).join("^");
    //       }
    //       reducedArray[count].description = userDescription.join("^")
    //     }
    //   }
    // }

    reducedArray.sort(function (a, b) {
      return b.dateTime.localeCompare(a.dateTime);
    })
    for (let i = 0; i < reducedArray.length; i++) {
		/* let date = new Date(reducedArray[i].dateTime+' GMT')
			let myMoment: moment.Moment = moment(date,'dd/MM/yyyy HH:mm:ss')*/
		/* var momentObj = moment(date); */
		/* let myMoment: moment.Moment = moment(new Date(reducedArray[i].dateTime+' GMT'),'dd/MM/yyyy HH:hh:ss') */
		let obj = {}
		obj['policyNumber'] = policyNumber;
        obj['userId'] = reducedArray[i].userId;
        /* obj['dateTime'] = this.datePipe.transform(reducedArray[i].dateTime+' GMT', "dd/MM/yyyy HH:hh:ss") */
		obj['dateTime'] =this.datePipe.transform(new Date(reducedArray[i].server_time+" GMT").toISOString(),"dd-MM-yyyy HH:mm:ss");
        /* obj['dateTime'] = myMoment */
		obj['description'] = (reducedArray[i].description);
		this.auditTrailData.push(obj);

    }
    this.dataTableRendering();
    this.dtTrigger.next();

  }
	/*
	* Created By : Manasa R
	* Description : To render a datatable after destroy.
	*********************************************/
  dataTableRendering() {
    if (($.fn.dataTable.isDataTable("#auditTrailDataTable"))) {
      $("#auditTrailDataTable").DataTable().destroy();
    }
    $("#auditTrailDataTable").DataTable({
      data: this.auditTrailData,
      "columns": [
        { data: "policyNumber" },
        {
          data: "userId"

        },
        { data: 'dateTime' },
        {
          data: null,
          render: function (data) {

            var dataToBreak = (data.description).split("gc_booking_date").join("GC Booking Date").
              split("renewal_counter").join("Renewal Counter").split("policy_type").join("Policy Type").split("policy_inception_date").join("Policy Inception Date")
              .split("portal_effective_date").join("Portal Effective Date").split("policy_expiry_date").join("Policy Expiry Date").split("portal_lock_date").join("Portal Lock Date")
              .split("producer_name").join("Producer Name").split("producer_code").join("Producer Code").split("producer_branch_name").join("Branch Location")
              .split("producer_phone_no").join("Producer Phone no.").split("producer_email").join("Producer Email ID").split("group_name").join("Selected Group Name")
              .split("insured_name").join("Insured Name").split("insured_add1").join("Insured Address 1").split("insured_add2").join("Insured Address 2").split("insured_add3").join("Insured Address 3")
              .split("insured_city").join("City").split("insured_country").join("Country").split("insured_zipcode").join("Postal / Zip Code").split("insured_gstin").join("GSTIN")
              .split("voyage_name").join("Voyage Name").split("low_balance_trigger_amount").join("Low Balance Trigger Amount").split("low_balance_trigger").join("Low balance Trigger")
              .split("marine_final_rate_percentage").join("Marine Final Rate % ").split("mode_of_conveyance").join("Mode of Conveyance")
              .split("coverage_type").join("Coverage Type").split("declaration_type_sub_voyage").join("Declaration Type Sub voyage").split("declaration_type").join("Declaration Type").split("sub_voyage_name").join("Sub_Voyage Type").split("certificate_bulk").join("certificate/bulk")
              .split("certificate_allowed").join("Certificate Allowed Yes/No").split("bulk_Declaration Type").join("Bulk Declaration Type").split("bov_percentage").join("BOV%")
              .split("per_seeding_limit").join("Per Sending Limit").split("transit_excees").join("Transit Excess").split("Transit Excess_in_certificate").join("Transit Excess")
              .split("mode_of_conveyance").join("Mode of Conveyance").split("min_shipment_premium").join("Minimum Shipment Premium").split("back_date_days").join("Number of days to backdate")
              .split("days_post_expiry").join("Days Post Expiry").split("display_premium").join("Premium Display").split("non_standard_clauses").join("Non-Std.Clauses")
              .split("from_country").join("From Country").split("to_country").join("To Country").split("client_in_certificate").join("Add Client in Certificate").split("underwriter_email").join("UnderWriter Email").split("policy_id").join("Policy Id")
              .split("si_percentage").join("SI%").split("SI%_bulk").join("SI%").split("SI%_certificate").join("SI%").split("opening_balance").join("Opening Balance").split("premium_balance").join("Premium Balance in INR").split("Premium Balance in INR_bulk").join("Premium Balance in INR").split("Premium Balance in INR_certificate").join("Premium Balance in INR").split("client_users").join("Client Users").split("producer_users").join("Producer Users")
              .split("tagic_rm_email").join("TAGIC RM Email ID").split("allow_certificate").join("allow Certificate").split("sub_Voyage Name").join("Sub Voyage Name").split("Opening Balance_certificateno").join("Opening Balance").split("Opening Balance_certificateyes").join("Opening Balance").split("Opening Balance_bulk").join("Opening Balance").split("Opening Balance_certificate").join("Opening Balance")
              .split("SI%yes").join("SI%").split("SI%no").join("SI%").split("Premium Balance in INRyes").join("Premium Balance in INR").split("Premium Balance in INRno").join("Premium Balance in INR")
              .split("policy_currency_type").join("Policy Currency Type").split("tax_applicable").join("Tax Applicable").split("net_premium_with_tax").join("Net premium with Tax").split("initial_sum_insured").join("initial SI").split("insured_id").join("Insurd Id")
              .split("policy_total_premium").join("Policy Total Premium").split("net_premium").join("Net Premium").split("transit_excess_in_certificate").join("Transit Excess")
            return '<div class="text-wrap">' + (dataToBreak).split("^").join("<br>") + '</div>'

          }

        },
      ],

      paging: false,
      info: false,
      autoWidth: false,
    }
    ).draw();
  }
	/*
	* Created By : Manasa R
	* Description : To Get add and remove producer user details.
	*********************************************/
  producerUserDetails(x, y) {
    //this.changes.push("producer_users")
    if(x.length>1 || y.length>1)
    {
      // when length of 'x' or 'y' greater than one
    }
    let removedProducerDetails=[];
    let deletedProducerDetails= x.filter(elm => !y.map(elm1 => JSON.stringify(elm1)).includes(JSON.stringify(elm)));
    let addedProducerDetails= y.filter(elm => !x.map(elm1 => JSON.stringify(elm1)).includes(JSON.stringify(elm))); 
   //let addedDataArray=[];
    for(var i in addedProducerDetails) {
    //addedDataArray.push(addedProducerDetails[i].email);
    removedProducerDetails = deletedProducerDetails.filter((item) => item.email !== addedProducerDetails[i].email);
  }
  if(addedProducerDetails.length>0){
    this.changes.push("Added producer_users")
    for (let count = 0; count < addedProducerDetails.length; count++) {
      for(let key in addedProducerDetails[count] )
      {
        this.changes.push(key+" : "+addedProducerDetails[count][key])
      }
    }
  }else {
    removedProducerDetails = JSON.parse(JSON.stringify(deletedProducerDetails));
  }

  
  if(removedProducerDetails.length>0){
    this.changes.push("Removed producer_users")
    for (let count = 0; count < removedProducerDetails.length; count++) {
     
      for(let key in removedProducerDetails[count] )
      {
       
        this.changes.push(key+" : "+removedProducerDetails[count][key])
    }
  }}
  }
	/*
	* Created By : Manasa R
	* Description : To equalise the JSON array for display.
	*********************************************/
 equalingJSON(x, y) {
   return new Promise(async resolve => {
     let differenceData = {};
     if (Object.keys(x).length > 0)
       for (let key in y) {
         if (Array.isArray(y[key])) {
           if (typeof y[key][0] === "object") {
             // differenceData[key] = [];
             // if (key == "producer_user") {
             //   if (x[key].length > y[key].length) {
             //     y[key].length = x[key].length
             //   }
             // }
             if (key == "producer_users") {
               this.producerUserDetails(x[key], y[key]);
             }
             else {
               for (let count = 0; count < y[key].length; count++) {
                 let xData = x[key][count] || {};
                 let yData = y[key][count];
                 for (let prop in yData) {
                   if (Array.isArray(yData[prop])) {
                     if (typeof yData[prop][0] === "object") {
                       if (prop == "producer_users") {
                         this.producerUserDetails(xData[prop], yData[prop]);
                       }
                       else {
                         for (let l = 0; l < yData[prop].length; l++) {
                           let incompletexData = xData[prop][l];
                           let incompleteyData = yData[prop][l];
                           for (let prop1 in incompleteyData) {
                             if (incompletexData[prop1] !== incompleteyData[prop1]) {
                               // differenceData[prop1] = yData[prop1];
                               if (incompleteyData[prop1] != "")
                                 this.changes.push(prop1 + " : " + incompleteyData[prop1])
                             }
                           }
                         }
                       }
                     }
                     else {
                       let arrayData = yData[prop].filter(function (n) { return !this.has(n) }, new Set(xData[prop]));
                       if (arrayData.length > 0) {
                         //differenceData[key] = arrayData;
                         let addedClientData = [];
                         for (let i = 0; i < arrayData.length; i++) {
                           addedClientData.push("email : " + arrayData[i])
                           /* if (i == arrayData.length - 1)
                             addedClientData.push("email : " + arrayData[i] )
                           else
                             addedClientData.push("email : " + arrayData[i]) */
                         }
                         this.changes.push("Added client_users", addedClientData)
                       }
                       let arrayRemoveData = xData[prop].filter(function (n) { return !this.has(n) }, new Set(yData[prop]));
                       if (arrayRemoveData.length > 0) {
                         //differenceData[key] = arrayData;
                         let RemovedClientData = [];
                         for (let i = 0; i < arrayRemoveData.length; i++) {
                           RemovedClientData.push("email : " + arrayRemoveData[i])
                           /* if (i == arrayRemoveData.length - 1)
                             RemovedClientData.push("email : " + arrayRemoveData[i] )
                           else
                             RemovedClientData.push("email : " + arrayRemoveData[i]) */
                         }
                         this.changes.push("Removed client_users", RemovedClientData)
                       }
                     }
  
                   }
                   else {
                     
                     if (xData[prop] !== yData[prop]) {
                       if (yData[prop] != "" && yData[prop] != null) {
                         // this.changes.push("producer_users")
                         this.changes.push(prop + " : " + yData[prop])
                       }
                       // differenceData[prop] = yData[prop];
                     }
                   }
                 }
                 //differenceData[key].push(sub_voyageObj)
               }
             }
           }
           else {
             let arrayData = y[key].filter(function (n) { return !this.has(n) }, new Set(x[key]));
             if (arrayData.length > 0) {
               //differenceData[key] = arrayData;
               let addedClientData = [];
               for (let i = 0; i < arrayData.length; i++) {
                   addedClientData.push("email : " + arrayData[i])
               }
               this.changes.push("Added client_users", addedClientData)
             }
             let arrayRemoveData = x[key].filter(function (n) { return !this.has(n) }, new Set(y[key]));
             if (arrayRemoveData.length > 0) {
               //differenceData[key] = arrayData;
               let RemovedClientData = [];
               for (let i = 0; i < arrayRemoveData.length; i++) {
                   RemovedClientData.push("email : " + arrayRemoveData[i])
               }
               this.changes.push(" Removed client_users", RemovedClientData)
             }
  
           }
         }
         else {
           if(key =="underwriter_email"){
               let xUnderWriterMail=x[key].split(",");
               let yUnderWriterMail=y[key].split(",");
               let arrayData = yUnderWriterMail.filter(function (n) { return !this.has(n) }, new Set(xUnderWriterMail));
               if (arrayData.length > 0) {
                 //differenceData[key] = arrayData;
                 let addedUnderWriterData = [];
                 for (let i = 0; i < arrayData.length; i++) {
                 addedUnderWriterData.push("email : " + arrayData[i])
                 }
                 this.changes.push("Added UnderWriter Users", addedUnderWriterData)
               }
               let arrayRemoveData =xUnderWriterMail.filter(function (n) { return !this.has(n) }, new Set(yUnderWriterMail));
               if (arrayRemoveData.length > 0) {
                 //differenceData[key] = arrayData;
                 let RemovedUnderWriterData = [];
                 for (let i = 0; i < arrayRemoveData.length; i++) {
                   RemovedUnderWriterData.push("email : " + arrayRemoveData[i])
                 }
                 this.changes.push(" Removed UnderWriter Users", RemovedUnderWriterData)
               }
  
           }else{
           if (x[key] !== y[key]) {
             // differenceData[key] = y[key];
             if (y[key] != "" && y[key] != null) {
               if (key == "portal_effective_date" || key == "portal_lock_date" || key == "policy_inception_date" || key == "policy_expiry_date" || key == "gc_booking_date")
                 this.changes.push(key + " : " + this.datePipe.transform(y[key], "dd/MM/yyyy"))
               else {
                 if (key == "tax_applicable") {
                   y[key] > 0 ? this.changes.push(key + " : " + "Yes") : this.changes.push(key + " : " + "No")
                 } else {
                   this.changes.push(key + " : " + y[key])
                 }
               }
             }
  
           }
         }
       }
       }
     else {
       for (let key in y) {
         if (Array.isArray(y[key])) {
           if (typeof y[key][0] === "object") {
             // differenceData[key] = [];
             if (key == "producer_users") {
               this.changes.push("Added" +key);
             }
             for (let count = 0; count < y[key].length; count++) {
               //let xData = x[key][count] ||{};
               let yData = y[key][count];
               for (let prop in yData) {               
                 if (Array.isArray(yData[prop])) {
                   if (typeof yData[prop][0] === "object") 
                   {
                     if (prop == "producer_users") {
                       this.changes.push("Added" +prop);
                     }
                     for (let l = 0; l < yData[prop].length; l++) {
                       //let incompletexData = yData[prop][l];
                       let incompleteyData = yData[prop][l];
                       for (let prop1 in incompleteyData) {
                         // if (incompletexData[prop1] !== incompleteyData[prop1]) {
                         // differenceData[prop1] = yData[prop1];
                         if (incompleteyData[prop1] != "" && incompleteyData[prop1] != null){
                          
                           this.changes.push(prop1 + " : " + incompleteyData[prop1])
                         }
                         //}
                       }
                     }
                   }
                   else {
                     let arrayData = yData[prop];
                     if (arrayData.length > 0) {
                       let addedClientData = [];
                       for (let i = 0; i < arrayData.length; i++) {
                         // if (i == arrayData.length - 1)
                         //   addedClientData.push("email : " + arrayData[i] + " has Added")
                         // else
                           addedClientData.push("email : " + arrayData[i])
                       }
                       this.changes.push("Added client_users", addedClientData)
                     }}
                 }
                 else {
                   // if (xData[prop] !== yData[prop]) {
                   if (yData[prop] != "" && yData[prop] != null)
                     this.changes.push(prop + " : " + yData[prop])
                   // differenceData[prop] = yData[prop];
                   // }
                 }
               }
               //differenceData[key].push(sub_voyageObj)
             }
           }
           else {
             let arrayData = y[key];
             if (arrayData.length > 0) {
               let addedClientData = [];
               for (let i = 0; i < arrayData.length; i++) {
                 // if (i == arrayData.length - 1)
                 //   addedClientData.push("email : " + arrayData[i] + " has Added")
                 // else
                   addedClientData.push("email : " + arrayData[i])
               }
               this.changes.push("Added client_users", addedClientData)
             }
           }
         }
         else {
           // if (x[key] !== y[key]) {
           // differenceData[key] = y[key];
           if (y[key] != "" && y[key] != null) {
             if (key == "portal_effective_date" || key == "portal_lock_date" || key == "policy_inception_date" || key == "policy_expiry_date" || key == "gc_booking_date")
               this.changes.push(key + " : " + this.datePipe.transform(y[key], "dd/MM/yyyy"))
             else if (key == "tax_applicable")
                {
                 y[key] > 0 ? this.changes.push(key + " : " + "Yes") : this.changes.push(key + " : " + "No")
               } 
               else if (key == "underwriter_email")
               {
                 this.changes.push("Added UnderWriter Users")
                 this.changes.push("email : "+y[key])
               }
               else {
                 this.changes.push(key + " : " + y[key])
               }
             
             // this.changes.push(key + " : " + y[key])
           }
           //}
         }
       }
     }
     // return differenceData;
     resolve(true);
   });   

  }
}
